import { ChangeEvent } from 'react'
import { FormGroup, Grid, MenuItem, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { AxiomaW1NominalDiameter, CatalogProductType } from '../enums'
import { CatalogProduct } from '../types'
import { AxiomaW1CatalogProduct } from '../types/CatalogProduct'
import { AxiomaW1CatalogProductCustomDataInput } from '../types/CatalogProductInput'
import CatalogProductForm from './CatalogProductForm'

const NOMINAL_DIAMETERS = Object.values(AxiomaW1NominalDiameter).filter(
  (diameter): diameter is AxiomaW1NominalDiameter => typeof diameter === 'number'
)

export interface AxiomaW1CatalogProductFormProps {
  catalogProduct?: AxiomaW1CatalogProduct
  onCancel?: () => void
  onError?: (error: unknown) => void
  afterSubmit?: (catalogProduct: CatalogProduct) => void
}

export default function AxiomaW1CatalogProductForm({
  catalogProduct,
  ...props
}: AxiomaW1CatalogProductFormProps) {
  return (
    <CatalogProductForm
      {...props}
      type={CatalogProductType.AXIOMA_W1}
      catalogProduct={catalogProduct}
    />
  )
}

export interface AxiomaW1CatalogProductCustomDataFieldsProps {
  value: AxiomaW1CatalogProductCustomDataInput
  catalogProduct?: CatalogProduct
  disabled?: boolean
  isError?: (field: string) => boolean
  getHelperText?: (field: string) => string | undefined
  onChange: (value: AxiomaW1CatalogProductCustomDataInput) => void
}

export function AxiomaW1CatalogProductCustomDataFields({
  value,
  disabled = false,
  isError,
  getHelperText,
  onChange
}: AxiomaW1CatalogProductCustomDataFieldsProps) {
  const { t } = useTranslation('catalogProduct')

  function handleNominalDiameterChange(event: ChangeEvent<HTMLInputElement>) {
    onChange({
      ...value,
      nominalDiameter: Number(event.target.value) as AxiomaW1NominalDiameter
    })
  }

  return (
    <FormGroup>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <TextField
            select
            label={`${t('axioma:nominalDiameter')} (mm)`}
            value={value.nominalDiameter ?? AxiomaW1NominalDiameter.DN25}
            error={isError?.('customData.nominalDiameter')}
            helperText={getHelperText?.('customData.nominalDiameter')}
            disabled={disabled}
            variant="outlined"
            fullWidth
            onChange={handleNominalDiameterChange}
          >
            {NOMINAL_DIAMETERS.map((diameter) => (
              <MenuItem key={diameter} value={diameter}>
                {diameter}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </FormGroup>
  )
}
